import PropTypes from "prop-types";
import React from "react";

import cx from "classnames";
import styles from "./styles.module.scss";

import { Row, Col } from "react-bootstrap";
import DOMPurify from "dompurify";
import InputField from "src/legacy/components/InputField";

import DeactivateIntegrationContainer from "src/legacy/components/DeactivateIntegration/index";
import { shouldFetchIntegrations } from "src/legacy/services/utils";
import { localizedStrings } from "src/localization/index.jsx";
import SwitchButton from "src/components/switchButton";

import _ from "lodash";
import { FirefliesSidebar } from "./FireFliesSidebar";

class FireFliesView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      deleteConfirmation: false,
      showIntergrationOnboarding: _.get(this.props, "integration") == 0,
      isScrollDisabled: false,
      selectedTab: null,
      apiKey: _.get(props, "integration.configuration.apiKey") || "",
      errors: {},
    };
    this.handleAuthenticate = this.handleAuthenticate.bind(this);
    this._handleDeactivateClicked = this._handleDeactivateClicked.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.disableScroll = this.disableScroll.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.canEdit = this.canEdit.bind(this);
    this.showIntergrationOnboarding = this.showIntergrationOnboarding.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedFireFlies = localizedStrings.components.integrations.fireflies;
    this.localizedCommons = localizedStrings.commons;
    this.localizedIntgerationActions = localizedStrings.components.integrations.actions;
  }

  componentDidMount() {
    if (shouldFetchIntegrations(this.props.integrations)) {
      this.props.fetchIntegrations();
    }
  }

  _handleDeactivateClicked() {
    this.setState({ deleteConfirmation: true });
  }

  canEdit() {
    return this.props.user.admin;
  }

  showIntergrationOnboarding() {
    this.setState({
      showIntergrationOnboarding: !this.state.showIntergrationOnboarding,
    });
  }

  disableScroll(value) {
    this.setState({ isScrollDisabled: value });
  }

  handleChange = () => {
    const current = this.isSelected();
    this.props.updateFireFliesRecordingToggle({ enabled: !current });
  };

  handleScroll = (e) => {
    if (this.state.isScrollDisabled) return;

    const integration =
      localizedStrings.constants.integrationsOnboarding.integrations.fireFlies;
    const sections = integration.sections;

    const buffer = 25;
    let selectedTabIndex = 0;
    for (let i = 0; i < sections.length; i++) {
      const sectionId = sections[i].id;
      const element = document.getElementById(sectionId);
      if (element) {
        const { top } = element.getBoundingClientRect();
        if (e.target.scrollTop >= top - buffer) {
          selectedTabIndex = i;
        }
      }
    }

    this.setState({ selectedTab: sections[selectedTabIndex].id });
  };

  _handleFieldChange(field, e) {
    this.setState({ [field]: e.target.value });
  }

  _validateForm() {
    var errors = {};
    if (!this.state.apiKey || this.state.apiKey.trim() == "") {
      errors["apiKey"] = this.localizedFireFlies.activate.error;
    }
    return errors;
  }

  handleAuthenticate() {
    let errors = this._validateForm();
    this.setState({ errors });
    if (Object.keys(errors).length > 0) return;

    this.props.activateAccount({ apiKey: this.state.apiKey });
  }

  render() {
    var isAuthenticated = false;

    if (
      this.props.integration &&
      this.props.integration.state.code === "ok" &&
      !this.props.error
    ) {
      isAuthenticated = true;
    }

    var isTokenExpired =
      _.get(this.props, "integration.state.code") === "auth_error";

    return (
      <div>
        <Row className={styles.row}>
          <Col md={3} className={styles.left}>
            <FirefliesSidebar
              integration={this.props.integration}
              handleAuthenticate={this.handleAuthenticate}
              showIntergrationOnboarding={this.showIntergrationOnboarding}
              _handleDeactivateClicked={this._handleDeactivateClicked}
              deactivating={this.props.deactivating}
              isAuthenticated={isAuthenticated}
              authenticating={this.props.authenticating}
              isTokenExpired={isTokenExpired}
              navigate={this.props.navigate}
              handleIntegrationsBackButton={this.props.handleIntegrationsBackButton}
              isShowIntegrationOnboardingEnabled={this.state.showIntergrationOnboarding}
              canEdit={this.canEdit}
            />
          </Col>
          <Col md={9} id="right" className={styles.right}>
            {!this.props.integration && !isAuthenticated && (
              <div className={styles.authorize}>
                <h3>{this.localizedFireFlies.activate.title}</h3>
                <p
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      this.localizedFireFlies.activate.sub_text
                    ),
                  }}
                />
              </div>
            )}

            {this.props.integration && !isAuthenticated && (
              <div className={styles.authorize}>
                <h2>{this.localizedFireFlies.expired.title}</h2>
                <p>{this.localizedFireFlies.expired.sub_text}</p>
              </div>
            )}

            {this.props.integration && isAuthenticated && (
              <div className={styles.authFinish}>
                <h3 className={styles.secondLine}>
                  {" "}
                  {this.localizedFireFlies.active.title}{" "}
                  <h4>
                    {" "}
                    {this.localizedFireFlies.active.email}:{" "}
                    <i>{this.props.integration.configuration.email}</i>
                  </h4>
                </h3>
              </div>
            )}

            {this.canEdit() && (
              <div className={styles.apiKeyAccess}>
                <div className={styles.headerContainer}>
                  <span className={styles.heading}>
                    {this.localizedFireFlies.activate.api_key_title}
                  </span>
                  <span className={styles.subText}>
                    {this.localizedFireFlies.activate.api_key_sub_text}
                  </span>
                </div>

                <p className={styles.errorMessage}>{this.props.error}</p>

                <div className={styles.form}>
                  <InputField
                    className={styles.field}
                    title={`${this.localizedFireFlies.activate.api_key}: `}
                    placeholder={this.localizedFireFlies.activate.placeholder}
                    value={this.state.apiKey}
                    onChange={this._handleFieldChange.bind(this, "apiKey")}
                    errorMessage={this.state.errors["apiKey"]}
                    disabled={isAuthenticated} 
                  />
                </div>
              </div>
            )}

            {this.canEdit() && (
              <div className={styles.callRecordingAccess}>
                <div className={styles.headerContainer}>
                  <span className={styles.heading}>call-recording access</span>
                  <span className={styles.subText}>
                    Allow Paperflite to access your Fireflies cloud recordings
                    and transcripts.
                  </span>
                </div>
                <SwitchButton
                  className={styles.switch}
                  checked={this.isSelected()}
                  handleCheck={() => this.handleChange()}
                />
              </div>
            )}

            <div className={styles.actions}>
              {((_.size(_.get(this.props, "integration")) > 0 &&
                !isAuthenticated) ||
                (_.size(_.get(this.props, "integration")) > 0 &&
                  isTokenExpired)) &&
                this.canEdit() && (
                  <button
                    onClick={() => this.handleAuthenticate()}
                    disabled={this.props.activating}
                    className={styles.button}
                  >
                    {this.props.activating
                      ? this.localizedIntgerationActions.activating + "..."
                      : this.localizedIntgerationActions.re_authenticate}
                  </button>
                )}

              {_.size(_.get(this.props, "integration")) == 0 &&
                !isAuthenticated &&
                this.canEdit() && (
                  <button
                    onClick={() => this.handleAuthenticate()}
                    disabled={this.props.activating}
                    className={styles.button}
                  >
                    {this.props.activating &&
                      this.localizedIntgerationActions.activating + "..."}
                    {!this.props.activating &&
                      this.localizedIntgerationActions.activate}
                  </button>
                )}

              {_.size(_.get(this.props, "integration")) > 0 &&
                isAuthenticated &&
                !isTokenExpired &&
                this.canEdit() && (
                  <button
                    className={styles.button}
                    disabled={this.props.deactivating}
                    onClick={() => this._handleDeactivateClicked()}
                  >
                    {this.props.deactivating &&
                      `${this.localizedIntgerationActions.deactivating}...`}
                    {!this.props.deactivating &&
                      this.localizedIntgerationActions.deactivate}
                  </button>
                )}
            </div>
          </Col>
        </Row>
        <DeactivateIntegrationContainer
          name="Fire Flies"
          type="fire_flies"
          message={localizedStrings.formatString(
            this.localizedFireFlies.sliders.deactivate.sub_text,
            {
              email:
                (this.props.integration &&
                  this.props.integration.configuration.email) ||
                "",
            }
          )}
          show={this.state.deleteConfirmation}
          onCancel={() => {
            this.setState({ deleteConfirmation: false });
          }}
        />
      </div>
    );
  }

  isSelected() {
    if (this.props.enabled !== null) {
      return this.props.enabled;
    }
    return this.props.integration?.configuration?.callRecordingEnabled ?? false;
  }
}

export default FireFliesView;